import React from 'react';
import { useParams } from 'react-router-dom';
import { useGoBack } from '../../hooks/useReturnNavigation';
import { useOKR } from '../../hooks';
import { Card } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';
import { ApprovalHistory } from '../../components/okr';

export const OKRApprovalHistory: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // Back to the OKR, with the OKR's own way back intact (utils/returnTo.ts).
  const goBack = useGoBack(`/okrs/${id}`);
  const { data: okr, isLoading, error } = useOKR(id!);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-cream">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error || !okr) {
    return (
      <div className="flex items-center justify-center h-screen bg-cream">
        <Card className="p-8 text-center">
          <p className="text-danger-600 mb-4">Failed to load OKR</p>
          <Button variant="secondary" onClick={goBack}>
            Back to OKRs
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <div className="bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center">
            <Button variant="secondary" onClick={goBack} className="mr-4">
              ← Back to OKR
            </Button>
            <div>
              <h1 className="text-3xl font-semibold text-stone-900" style={{ fontFamily: 'Fraunces, Georgia, serif' }}>Approval History</h1>
              <p className="mt-1 text-sm text-stone-500">{okr.title}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ApprovalHistory
          okrId={okr.id}
          createdBy={okr.createdBy}
          createdByRole={okr.createdBy?.role}
        />
      </div>
    </div>
  );
};
